import { useTranslate } from '@growtherapy/i18n';
import { ActionItem, ActionList, Link } from '@growtherapy/sprout-ui';

import { getAppConfig } from '../../config';
import { Translate } from '../../i18n/Translate';

export function NoShowActionList() {
  const t = useTranslate();
  const marketplaceOrigin = getAppConfig().marketplaceOrigin;

  return (
    <div className='flex w-fit max-w-3xl'>
      <ActionList
        title={t('telehealth-core:providerNotHere.wereHereToHelpWhenYoureReady')}
        footer={
          <Translate
            i18nKey='telehealth-core:providerNotHere.ifYouNeedAdditionalSupport'
            components={{
              1: (
                <Link href={`${marketplaceOrigin}/client-dashboard`} className='text-neutral-700 font-normal text-sm' />
              ),
            }}
          />
        }
      >
        <ActionItem
          title={t('telehealth-core:providerNotHere.chatWithYourProvider')}
          description={t('telehealth-core:providerNotHere.messageYourProviderWithAnyQuestionsOrFeedback')}
          action={
            <Link buttonUse='primary' href={`${marketplaceOrigin}/client-dashboard/messages`} className='w-full'>
              {t('telehealth-core:providerNotHere.messageProvider')}
            </Link>
          }
        />
        <ActionItem
          title={t('telehealth-core:providerNotHere.findSomeoneNew')}
          description={t('telehealth-core:providerNotHere.findANewProviderThatMeetsYourNeeds')}
          action={
            <Link
              buttonUse='secondary'
              href={`${marketplaceOrigin}/filters?utm_source=telehealth-booking`}
              className='w-full'
            >
              {t('telehealth-core:providerNotHere.findNewProvider')}
            </Link>
          }
        />
      </ActionList>
    </div>
  );
}
